import React from 'react';
import { useSelector } from 'react-redux';

// components
import { HeaderNav } from 'app-components';

// selectors
import { environmentSelector } from '@selectors/commonSelectors';

// constants
import { configs } from '@constants/configs/configs';

//Hooks
import { useTopNavMenu } from '@hooks/useTopNavMenu';


const TopNavHeader = () => {
    const {
        stateCode,
        impersonation,
        impersonationDetails,
        user: {
            activeModuleName,
            role,
            roles,
            roleLabels,
            userActiveRole
        },
        links: {
            SETTINGS
        }
    } = useSelector(environmentSelector);
    const { endpoints } = configs;
    const roleLabel = (!impersonation && !impersonationDetails && activeModuleName)
        ? roleLabels[activeModuleName.toUpperCase()]
        : (sessionStorage.getItem('userActiveRoleLabel') || roleLabels[userActiveRole]);
    const { TopNavMenuComponent } = useTopNavMenu(userActiveRole, roleLabel, roleLabels, roles, role, endpoints, SETTINGS, stateCode);

    return (
        <HeaderNav isTopNav={true} stateCode={stateCode} hasSubMenu={true}>
            <TopNavMenuComponent />
        </HeaderNav>
    );
};
export default TopNavHeader;